import { Box, Text, Divider, Heading } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { PageHeader } from 'packages/common-frontend/components/PageContainer';
import { RailzConnectContainer } from 'packages/financial-data/ui/railz/RailzConnectContainer';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  return (
    <Box id="accounting-integrations-container">
      <PageHeader headerLabel="Connect your accounting system" />
      <Text width="100%" mt="10px" fontSize="sm" align="left">
        Accounting systems are important financial data sources for debt capital
        compliance and monitoring.
      </Text>

      <Divider my="6" />

      <Box>
        <Heading as="h4" size="md" textAlign="left" mb="5">
          Railz Connections
        </Heading>
        <RailzConnectContainer organizationId={user.organization.id} />
      </Box>
    </Box>
  );
};

// Exports
export const permissions: PermissionsFn = (context) => {
  if (context.user.userType !== 'BORROWER') return 'deny';
  if (!context.flags.enableRailzIntegration) return 'deny';
  if (context.flags.isBorrowerLimitedOrganization) return 'upsell';
  return 'allow';
};
export const Route = () => (
  <PermissionGuard
    permissions={permissions}
    fallback={<Navigate to="/settings" replace />}
  >
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  </PermissionGuard>
);
